// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3tgoe","topBottomGutter":"Layout_topBottomGutter__3xD04"};